import React, { useState } from 'react';
import { Box, CssBaseline, Divider, List, Toolbar, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { ChevronRight } from '@mui/icons-material';
import NewNavbar from '../../components/Navbar/New/Navbar';
import { SettingsListItems } from '../../features/settings/SettingsListItems';
const DRAWER_WIDTH = 240;

const Drawer = styled(MuiDrawer)(({ theme, open }) => ({
  '& .MuiDrawer-paper': {
    position: 'fixed',
    top: 64,
    left: 0,
    height: 'calc(100vh - 64px)',
    whiteSpace: 'nowrap',
    width: open ? DRAWER_WIDTH : theme.spacing(7),
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: open
        ? theme.transitions.duration.enteringScreen
        : theme.transitions.duration.leavingScreen,
    }),
    boxSizing: 'border-box',
    overflowX: 'hidden',
    overflowY: open ? 'auto' : 'hidden',
  },
}));

const SettingsLayout = ({ children }) => {
  const [open, setOpen] = useState(true);

  const toggleDrawer = () => setOpen((prev) => !prev);

  return (
    <Box display="flex">
      <CssBaseline />
      <NewNavbar />

      <Drawer variant="permanent" open={open}>
        {/* Drawer header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            my: 2,
            p: 1,
            width: '100%',
          }}
        >
          {open && (
            <Typography
              variant="subtitle1"
              color="text.primary"
              sx={{
                pl: 1,
                fontWeight: 600,
                whiteSpace: 'break-spaces',
                lineHeight: '1.5rem',
                textAlign: 'left',
              }}
            >
              Settings
            </Typography>
          )}

          {open ? (
            <ChevronLeftIcon
              sx={{
                fontSize: 22,
                backgroundColor: '#1b3f87',
                color: '#ffffff',
                borderRadius: '50%',
                cursor: 'pointer',
              }}
              onClick={toggleDrawer}
            />
          ) : (
            <Box sx={{ p: 1 }}>
              <ChevronRight
                onClick={toggleDrawer}
                sx={{
                  fontSize: 22,
                  backgroundColor: '#1b3f87',
                  color: '#ffffff',
                  borderRadius: '50%',
                  cursor: 'pointer',
                }}
              />
            </Box>
          )}
        </Box>

        <Divider />

        <List component="nav" sx={{ padding: 0 }}>
          <SettingsListItems open={open} />
          <Divider sx={{ my: 1 }} />
        </List>
      </Drawer>

      {/* Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
          padding: '16px',
          ml: open ? `${DRAWER_WIDTH}px` : 7,
          transition: (theme) =>
            theme.transitions.create('margin-left', {
              easing: theme.transitions.easing.sharp,
              duration: open
                ? theme.transitions.duration.enteringScreen
                : theme.transitions.duration.leavingScreen,
            }),
        }}
      >
        <Toolbar />
        <Box sx={{ flexGrow: 1, padding: '16px' }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default SettingsLayout;